import {Component, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {environment} from 'src/environments/environment';
import {CookieConsentService} from '../cookie-consent-dialog/cookie-consent.service';

@Component({
    selector: 'app-core-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    standalone: false
})
export class LoginPageComponent implements OnDestroy{
  callback: boolean;

  constructor(oauthService: OAuthService, router: Router, public cookieConsentService: CookieConsentService) {

    if (this.cookieConsentService.dialogRef) {
      this.cookieConsentService.dialogRef.afterClosed().subscribe(() => {
        this.configureOauth(oauthService, router);
      });
    } else {
      this.configureOauth(oauthService, router);
    }

  }

  private configureOauth(oauthService, router) {
    oauthService.configure(environment.authConfig);
    oauthService.loadDiscoveryDocumentAndLogin().then(loggedIn => {
      if (loggedIn) {
        top.location.reload();
        window.location.href = '';
        return;
      }
    });
  }

  ngOnDestroy() {
    if (this.cookieConsentService.dialogRef) {
      this.cookieConsentService.dialogRef.afterClosed().unsubscribe();
    }
  }
}
